import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { useEditorUIContext } from '../contexts/EditorUIContext';
import { TextColorIcon } from 'foundations-assets/icons/components/TextColorIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ToggleFormattingTray() {
  const {
    showFormattingTray,
    setShowFormattingTray
  } = useEditorUIContext();
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: showFormattingTray ? 'hubspot-prosemirror.tooltips.hideFormattingTray' : 'hubspot-prosemirror.tooltips.showFormattingTray'
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      "data-test-id": "formatting-tray",
      onClick: () => setShowFormattingTray(!showFormattingTray),
      selected: showFormattingTray,
      children: /*#__PURE__*/_jsx(TextColorIcon, {
        color: "fill-accent-neutral-default"
      })
    })
  });
}